export default {"src":"/_next/static/media/rep.583749a4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};